export default defineNuxtRouteMiddleware((to, from) => {
    // 拦截路由
    const interceptRouteRegex = [/components/, /component/];

    if (interceptRouteRegex.find(o => o.test(to.fullPath))) {
        return navigateTo('/404', {replace: true,})
    }
})